import * as React from 'react';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export const VipAndPropertyTypeBadge = ({ vipMessage, propertyTypeBadge, recentlyViewed, isDatelessPdp }) =>
  (vipMessage || propertyTypeBadge || recentlyViewed) && !isDatelessPdp ? (
    <div className="uitk-cell all-cell-1-1 all-b-margin-one">
      {recentlyViewed && <RecentlyViewed recentlyViewed={recentlyViewed} addSeparator={vipMessage || propertyTypeBadge} />}
      {vipMessage && <span className="uitk-type-300 uitk-type-medium listing-vip">{vipMessage}</span>}
      {vipMessage && propertyTypeBadge && <span className="uitk-type-300 uitk-type-bold all-x-margin-two">&#183;</span>}
      {propertyTypeBadge && (
        <span className="uitk-type-regular pwa-theme--grey-700 uitk-type-300 listing-structure-type">{propertyTypeBadge}</span>
      )}
    </div>
  ) : null;

const RecentlyViewed = ({ recentlyViewed, addSeparator }) => (
  <>
    {recentlyViewed.icon && (
      <UitkIcon
        name={recentlyViewed.icon}
        size={UitkIconSize.SMALL}
        className="pwa-theme--grey-700 all-cell-align-middle all-b-padding-half"
      />
    )}
    <span className="uitk-type-regular pwa-theme--grey-700 uitk-type-300 listing-recently-viewed">{recentlyViewed.message}</span>
    {addSeparator && <span className="uitk-type-300 uitk-type-bold all-x-margin-two">&#183;</span>}
  </>
);
